var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrivaIgniteDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#E3F0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6281 18.6736H14.1692C12.6854 18.6736 11.9436 18.6736 11.6274 18.1844C11.3111 17.6953 11.6124 17.0138 12.215 15.6508L14.0267 11.5532C14.5746 10.314 14.8485 9.69438 15.38 9.34719C15.9114 9 16.5859 9 17.935 9H20.0244C21.6632 9 22.4826 9 22.7916 9.53535C23.1007 10.0707 22.6942 10.7859 21.8811 12.2162L20.8092 14.1019C20.405 14.813 20.2029 15.1685 20.2057 15.4595C20.2094 15.8378 20.4105 16.1862 20.7354 16.377C20.9854 16.5239 21.3927 16.5239 22.2074 16.5239C23.2373 16.5239 23.7523 16.5239 24.0205 16.7022C24.3689 16.9338 24.5513 17.3482 24.4874 17.7632C24.4382 18.0826 24.0918 18.4656 23.399 19.2317L17.8639 25.3523C16.7767 26.5545 16.2331 27.1556 15.8681 26.9654C15.503 26.7751 15.6783 25.9822 16.0289 24.3962L16.7157 21.2896C16.9826 20.082 17.1161 19.4782 16.7951 19.0759C16.4741 18.6736 15.8588 18.6736 14.6281 18.6736Z",
    stroke: "#7D9D12",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivaIgniteDesktop);
export default __webpack_public_path__ + "static/media/triva_ignite_desktop.0fc374ba39e08b61bb17aee9f7ff1d9b.svg";
export { ForwardRef as ReactComponent };